import { render, staticRenderFns } from "./membershipcard.vue?vue&type=template&id=23956808&"
import script from "./membershipcard.vue?vue&type=script&lang=js&"
export * from "./membershipcard.vue?vue&type=script&lang=js&"
import style0 from "./membershipcard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports